import { Menu } from "@headlessui/react";
import { ArrowRightOnRectangleIcon } from "@heroicons/react/20/solid";
import { EMAIL_KEY, signOut } from "../../../../pages/protected-route";
import { UserCircleIcon } from "@heroicons/react/24/outline";
import { AccountMenuContent } from "./AccountMenuContent";
import { ChevronsUpDown } from "lucide-react";

export const AccountMenu = () => {
  return (
    <div className="w-full relative">
      <Menu>
        <div className="relative">
          <Menu.Items className="w-full dark:bg-dark-secondary bg-white !outline-none border dark:border-white/5 rounded-md shadow-lg absolute bottom-0 mb-2.5">
            <AccountMenuContent />
          </Menu.Items>
        </div>
        <Menu.Button className="!outline-none w-full dark:bg-dark-secondary rounded-lg border dark:border-white/5 shadow-md bg-white">
          <div className="flex py-2">
            <div className="px-2">
              <div className="rounded-lg dark:bg-dark-primary bg-white ring-1 ring-zinc-200 dark:ring-white/10 p-1.5">
                <UserCircleIcon className="h-6 w-6 dark:text-zinc-200 text-zinc-400" />
              </div>
            </div>
            <div className="flex-1 flex overflow-hidden">
              <div className="relative w-full overflow-hidden">
                <p
                  aria-hidden="true"
                  title={localStorage.getItem(EMAIL_KEY) || ""}
                  className="font-medium truncate overflow-hidden whitespace-nowrap text-ellipsis text-xs max-w-[11rem] text-left text-zinc-600 dark:text-zinc-200"
                >
                  {localStorage.getItem(EMAIL_KEY)}
                </p>
                <div className="flex items-center text-xs font-light text-zinc-500 dark:text-zinc-400">
                  <p aria-hidden="true">View Settings</p>
                </div>
              </div>
            </div>
            <div className="flex items-center px-2">
              <ChevronsUpDown className="h-5 w-5 dark:text-white text-zinc-500" />
            </div>
          </div>
        </Menu.Button>
      </Menu>
    </div>
  );
};
